module.exports = __webpack_public_path__ + "static/midiagnostico-logo-978a16948ae8f6a28aaf8064b620e786.png";